// Internal imports (Redux slices)
import { fetchClientsStart, fetchClientsSuccess, fetchClientsFailure } from './clientSlice';

// External imports (Redux Saga and effects)
import { takeLatest, put, call, CallEffect, PutEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

// API services
import { ContractService } from '@/api/services/contractService';

// Models
import { Client } from '@/api/models/Client';
import { ClientRequest } from '@/api/models/BaseRequest';

function* fetchClientsSaga(): Generator<CallEffect<Client[]> | PutEffect, void, Client[]> {
  try {
    const payload: ClientRequest = {
      keyword: '',
      pageNo: 0,
      pageSize: 0,
      user: '',
    };
    const clients: Client[] = yield call(ContractService.fetchClients, payload);
    yield put(fetchClientsSuccess(clients));
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Fetching clients failed';
    yield put(fetchClientsFailure(errorMessage));
  }
}

// Watcher Saga
export function* watchClients(): SagaIterator {
  yield takeLatest(fetchClientsStart.type, fetchClientsSaga);
}
